<template>
  <span :class="badgeClass" class="badge fs-10 px-3" @click="$emit('click')" style="cursor: pointer;">
    <i :class="statusIcon" v-if="showIcon"></i>
    <span>{{ displayText }}</span>
  </span>
</template>

<script>
export default {
  name: 'VendorStatus',
  props: {
    status: {
      type: String,
      required: true
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    badgeClass() {
      const classes = {
        'pending': 'badge-warning-subtle text-warning',
        'approved': 'badge-success-subtle text-success',
        'conditionaly_approved': 'badge-info-subtle text-info',
        'rejected': 'badge-danger-subtle text-danger'
      }
      return classes[this.status] || 'badge-secondary-subtle text-secondary'
    },
    displayText() {
      const texts = {
        'conditionaly_approved': 'Conditionaly Approved'
      }
      return texts[this.status] || this.status
    },
    statusIcon() {
      const icons = {
        'pending': 'fas fa-clock',
        'approved': 'fas fa-check-circle',
        'conditionaly_approved': 'fas fa-check-circle',
        'rejected': 'fas fa-times-circle'
      }
      return icons[this.status] || 'fas fa-tag'
    }
  }
}
</script>

<style scoped>
.badge {
  font-weight: 700;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-transform: capitalize;
}

.fs-10 {
  font-size: 10px;
}

.badge-warning-subtle {
  background-color: #fff3e0;
  color: #ff7300;
}

.badge-success-subtle {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.badge-danger-subtle {
  background-color: #ffebee;
  color: #ff0000;
}

.badge-primary-subtle {
  background-color: #e3f2fd;
  color: #1976d2;
}

.badge-secondary-subtle {
  background-color: #f5f5f5;
  color: #757575;
}

.badge-info-subtle {
  background-color: #e0f7fa;
  color: #0097a7;
}

.badge-dark-subtle {
  background-color: #eceff1;
  color: #455a64;
}
</style>
